import { useEffect } from "react";
import { useLazyGetProfileOrdersQuery } from "../../../../../../../services/Customer/CustomerOrderList/customerOrderListAPI";

interface Props {
  autoFetch: boolean;
  affAbo: string;
  pageNum: number;
  pageSize: number;
  period: string;
  sortValue: string;
  sortOrder: string;
  customerIds: number;
  searchBy?: string;
  businessNature?: string;
  locale?: string;
  requestWithSponsor?: boolean;
}

const useGetProfileOrders = ({
  autoFetch,
  affAbo,
  pageNum,
  period,
  pageSize,
  sortOrder,
  sortValue,
  customerIds,
  searchBy,
  businessNature,
  locale,
  requestWithSponsor,
}: Props) => {
  const [getProfileOrders] = useLazyGetProfileOrdersQuery();

  useEffect(() => {
    if (autoFetch === true) {
      getProfileOrders({
        affAbo,
        pageSize,
        pageNum,
        period,
        sortValue,
        sortOrder,
        customerIds,
        searchBy,
        businessNature,
        locale,
        requestWithSponsor,
      });
    }
  }, [
    affAbo,
    autoFetch,
    customerIds,
    getProfileOrders,
    pageNum,
    pageSize,
    period,
    sortOrder,
    sortValue,
    searchBy,
    businessNature,
    locale,
    requestWithSponsor,
  ]);
};

export default useGetProfileOrders;
